import httpClient from "./httpClient";

const base = "/class-teacher-assign";

export function listClassTeacherAssigns() {
  return httpClient.get(base).then((res) => res.data.data);
}

export function assignClassTeacher(staffId, classConfigIds) {
  const params = new URLSearchParams();
  params.append("staffId", staffId);
  classConfigIds.forEach((id) => params.append("classConfigIds", id));
  return httpClient.post(`${base}?${params.toString()}`).then((res) => res.data);
}

export function deleteClassTeacherAssign(assignIds) {
  const params = new URLSearchParams();
  assignIds.forEach((id) => params.append("assignIds", id));
  return httpClient.delete(`${base}?${params.toString()}`).then((res) => res.data);
}
